module.exports = __webpack_public_path__ + "img/file_upload.8a726b80.svg";